@let clientHasLog = clientHasLog$ | async;
<div class="catalog-library">
  @if (displayMode === 'all') {
    <ng-container>
      @if ((isLoading$ | async) !== true) {
        <ng-container>
          @if (hasFavorites$ | async) {
            <ng-container>
              <ng-container
                [ngTemplateOutlet]="section"
                [ngTemplateOutletContext]="{
                  title: 'myFavoriteVideos',
                  contents: (videos$ | async),
                  contentType: ContentTypes.Video,
                  itemType: CarouselItem.VideoDetail,
                }"></ng-container>
              <ng-container
                [ngTemplateOutlet]="section"
                [ngTemplateOutletContext]="{
                  title: 'myFavoriteGpsTracks',
                  contents: (gpsTracks$ | async),
                  contentType: ContentTypes.GpsTrack,
                  itemType: CarouselItem.GpsDetail,
                }"></ng-container>
              <ng-container
                [ngTemplateOutlet]="section"
                [ngTemplateOutletContext]="{
                  title: 'myFavoriteStructuredWorkouts',
                  contents: (workouts$ | async),
                  contentType: ContentTypes.Workout,
                  itemType: CarouselItem.WorkoutDetail,
                }"></ng-container>
              <ng-container
                [ngTemplateOutlet]="section"
                [ngTemplateOutletContext]="{
                  title: 'myFavoriteCoachings',
                  contents: (coachings$ | async),
                  contentType: ContentTypes.Coaching,
                  itemType: CarouselItem.CoachingDetail,
                }"></ng-container>
              <ng-container
                [ngTemplateOutlet]="section"
                [ngTemplateOutletContext]="{
                  title: 'myFavoritePlaylists',
                  contents: (playlists$ | async),
                  contentType: ContentTypes.Playlist,
                  itemType: CarouselItem.Playlist,
                }"></ng-container>
            </ng-container>
          } @else if (!(hasFavorites$ | async) && !clientHasLog) {
            <div class="not-log-favorites">
              <kin-header-block
                [label]="'browse.myFavorites' | translate"
                [size]="'medium'"
                [viewMoreDisplay]="false" />
              <kin-no-data-block
                [logged]="false"
                [noLoggedLabel]="
                  'browse.favorites_content.not_logged' | translate
                "
                [noLoggedButton]="'common.signin' | translate"
                (onClick)="loginService.redirectToOauth()" />
              <kin-header-block
                [label]="
                  'browse.favorites.titles.myFavoritePlaylists' | translate
                "
                [size]="'medium'"
                [viewMoreDisplay]="false" />
              <kin-no-data-block
                [logged]="false"
                [noLoggedLabel]="'browse.favorites.not_logged' | translate"
                [noLoggedButton]="'common.signin' | translate"
                (onClick)="loginService.redirectToOauth()" />
            </div>
          } @else {
            <ng-container>
              <div class="no-content">
                {{ 'browse.favorites.noContentAvailable' | translate }}
              </div>
            </ng-container>
          }
        </ng-container>
      } @else {
        <ng-container>
          <div class="loading-container">
            <app-loader></app-loader>
          </div>
        </ng-container>
      }
    </ng-container>
  } @else {
    <ng-container>
      <div class="back-btn-wrapper">
        <app-back-button
          [hasLinkStyle]="true"
          (goBack)="onSwitchDisplayMode('all')"></app-back-button>
      </div>
      <app-listing [modeName]="ModeNames.Library" [contentType]="displayMode" />
    </ng-container>
  }
</div>

<ng-template
  #section
  let-title="title"
  let-contents="contents"
  let-contentType="contentType"
  let-itemType="itemType">
  @if (contents?.length > 0) {
    <div class="section">
      <div class="section-title">
        <span class="title">
          {{ 'browse.favorites.titles.' + title | translate }}
        </span>
        <a class="see-all" (click)="onSwitchDisplayMode(contentType)">
          <span> {{ 'browse.seeAll' | translate }} </span>
          <span class="icon icon-arrow-right"></span>
        </a>
      </div>
      <app-browse-carousel
        [itemType]="itemType"
        [videos]="contentType === ContentTypes.Video ? contents : []"
        [gpsTracks]="contentType === ContentTypes.GpsTrack ? contents : []"
        [workouts]="contentType === ContentTypes.Workout ? contents : []"
        [coachings]="contentType === ContentTypes.Coaching ? contents : []"
        [playlists]="contentType === ContentTypes.Playlist ? contents : []" />
    </div>
  }
</ng-template>
